import styled, { css } from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';
import { fadeIn } from '~src/styles/animations/animations.sc';

export const DebounceInputWrapper = styled.span<{ $focused: boolean }>`
  & input {
    width: ${({ $focused }) => ($focused ? '325px' : '100%')};
    left: 4.05rem;
    top: 18.25rem;
    height: 4rem;
    cursor: ${({ $focused }) => ($focused ? 'text' : 'auto')};
    padding: 1rem 1rem 1rem ${({ $focused }) => ($focused ? '1.5rem' : '1rem')};
    background-color: ${({ theme }) => theme.white.a10};
    transition: width 1s ease;
    color: ${({ $focused, theme }) => ($focused ? theme.baseBlue.a10 : 'inherit')};

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${({ theme }) => theme.baseBlue.a6};
    }
  }
`;

export const SideBarBackground = styled.div`
  position: fixed;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  width: 60px;
  height: 100%;
  background-color: ${({ theme }) => theme.background};
  /* consider that max z-index for antd components like date-picker is 1050 */
  z-index: 9998;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.03);
  ${media.phone`
    display: none;
  `};
  @media print {
    display: none;
  }
`;

export const SideBarWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px;
  height: 100%;
  ${media.phone`
    display: none;
  `};
`;

export const SubNavContainer = styled.div<{
  $fixed?: boolean;
  $full?: boolean;
  $offset?: number | null;
}>(
  ({ $fixed, $full, theme }) => css`
    cursor: pointer;
    display: ${$fixed ? 'block' : 'none'};
    width: ${$fixed ? '370px' : '340px'};
    z-index: ${$fixed ? 1000 : 1001};
    background-color: ${theme.white.a10};
    position: absolute;
    left: 4rem;
    box-shadow: 4px 0 14px 0 rgba(0, 0, 0, 0.03);
    animation: ${fadeIn} 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    height: fit-content;
    transition: width 0.4s ease;
    top: 0;
    max-height: ${$full ? '100%' : '100vh'};
    overflow: ${$full ? 'initial' : 'auto'};
    border-radius: 0 6px 6px 0;
  `,
);

export const BottomIcon = styled.div<{ $selected?: boolean }>`
  background-color: ${({ $selected, theme }) => ($selected ? theme.white.a10 : 'none')};
  margin-top: auto;
  border-top: solid 1px rgba(29, 29, 38, 0.06);
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.white.a10};
    box-shadow: 0 -1px 54px -11px rgba(0, 0, 0, 0.75);
  }

  height: 60px;
  width: 60px;

  @media (max-height: 420px) {
    height: auto;
    padding: 10px;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  z-index: 9999;
`;

export const LogoutIcon = styled(BottomIcon)`
  margin-top: 0;
`;

export const IconContainer = styled.div<{ $selected?: boolean }>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: ${({ $selected, theme }) => ($selected ? theme.baseBlue.a10 : 'inherit')};
  }
`;

export const ExitIcon = styled(SvgIcon)`
  width: 22px;
  height: 22px;
`;
